<template>
  <card dis-hover class="amendments-item" @click.native="goToAmendment">
    <div class="amendments-item__header">
      <div class="amendments-item__code ms-subhead">
        ДС №{{ amendment.number }} от {{ formatDefaultDate(amendment.date) }}
      </div>
      <div class="amendments-item__actions">
        <tag :color="getContractStatusColor(amendment.contract_info.status)">
          {{ amendment.contract_info.status }}
        </tag>
        <i-button
          class="amendments-item__button"
          type="primary"
          @click.native.stop="handleButtonClick('edit')"
          v-if="getContractModulePerms('amendments', 'update')"
        >
          Редактировать
        </i-button>
      </div>
    </div>
    <div class="amendments-item__dates">
      <div class="amendments-item__date start">
        <span class="ms-help"
          >Начало:
          {{ formatDefaultDate(amendment.contract_info.start_date) }}
        </span>
      </div>
      <div class="amendments-item__date end">
        <span class="ms-help"
          >Окончание:
          {{ formatDefaultDate(amendment.contract_info.end_date) }}
        </span>
      </div>
    </div>
    <div class="amendments-item__costs">
      <tag class="ms-costs" color="primary">
        {{
          getFormattedCosts(
            amendment.contract_info.costs,
            false,
            amendment.contract_info.with_vat
          )
        }}
      </tag>
    </div>
  </card>
</template>

<script>
import {
  getFormattedCosts,
  getContractStatusColor,
  formatDefaultDate
} from '@/utils'

export default {
  props: ['amendment'],
  data () {
    return {
      contractId: this.$route.params.id
    }
  },
  methods: {
    handleButtonClick (type) {
      this.$emit(type, this.amendment)
    },
    goToAmendment (e) {
      this.$router.push(
        `/app/contracts/${this.contractId}?amendment_id=${this.amendment.id}`
      )
    },
    getContractStatusColor,
    getFormattedCosts,
    formatDefaultDate
  }
}
</script>

<style lang="less">
.amendments-item {
  margin-bottom: 16px;
  cursor: pointer;

  &:hover {
    border-color: rgba(@primary-color, 0.6) !important;

    .amendments-item__button {
      display: inline-block;
    }
  }

  &__button {
    display: none;
    margin-left: 8px;

    &.ivu-btn {
      border: none;
      height: 22px;
      line-height: 22px;
    }
  }

  &__header {
    display: flex;
    justify-content: space-between;
  }

  &__actions {
    margin-left: 16px;
    flex-shrink: 0;

    .ivu-tag {
      margin: 0;
    }
  }

  &__name {
    margin-top: 4px;
  }

  &__companies {
    margin-top: 4px;
  }

  &__company {
    .ms-text {
      margin-right: 4px;
    }
  }

  &__dates {
    display: flex;
    margin: 8px 0;
  }

  &__date {
    width: 50%;
  }
}
</style>
